import type { EventItem } from '@/types/Event';

const selectedEvent = ref<EventItem | null>(null);

export const useEventDetail = () => ({
  selectedEvent: readonly(selectedEvent),
  open: (event: EventItem) => {
    selectedEvent.value = event;
  },
  close: () => {
    selectedEvent.value = null;
  },
});
